import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 4l0 16","key":"svg-0"}]]

const IconLetterI = createReactComponent('outline', 'letter-i', 'LetterI', __iconNode);

export default IconLetterI;